import { MENU_CODE, returnIconByMenuCode } from "constants/layout";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const menu = [
  {
    id: 1001,
    menuName: "Quản lý đơn vị vận chuyển",
    menuCode: "GS_MENU_SHIPPING_UNIT_MANAGE",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: null,
    children: [
      {
        id: 1002,
        menuName: "Danh sách đơn vị vận chuyển",
        menuCode: "GS_MENU_SHIPPING_UNIT_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/shipping-unit/list",
        children: [],
      },
      {
        id: 1003,
        menuName: "Thêm mới đơn vị vận chuyển",
        menuCode: "GS_MENU_SHIPPING_UNIT_ADD",
        menuOrder: 40,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/shipping-unit/create",
      },
    ],
  },
  {
    id: 1004,
    menuName: "Danh muc",
    menuCode: "GS_MENU_CONFIG_MANAGE",
    menuOrder: 10,
    parentId: null,
    sys: null,
    superAdmin: null,
    urlPropertyName: null,
    moduleName: "home",
    menuType: null,
    menuPublic: null,
    accessLink: null,
    children: [
      {
        id: 1005,
        menuName: "Danh sách chành xe",
        menuCode: "GS_MENU_BUS_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/bus/list",
        children: [],
        moreAccessLink: ["/bus/create"],
      },
      {
        id: 1006,
        menuName: "Danh sách tuyến vận chuyển",
        menuCode: "GS_MENU_ROUTE_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/route/list",
        children: [],
        moreAccessLink: ["/route/create"],
      },
      {
        id: 1007,
        menuName: "Danh sách khách hàng",
        menuCode: "GS_MENU_CUSTOMER_LIST",
        menuOrder: 20,
        parentId: 34,
        sys: null,
        superAdmin: null,
        urlPropertyName: "",
        moduleName: "home",
        menuType: null,
        menuPublic: null,
        accessLink: "/customer/list",
        children: [],
        moreAccessLink: ["/customer/create"],
      },
    ],
  },
];

const ConfigMenu = props => {
  const { menuApi } = props;
  // const menuMain = [...menuApi];
  const menuMain = [...menu];
  return (
    <React.Fragment>
      {menuMain.map((childItem, index) => {
        return (
          <React.Fragment key={childItem.id}>
            <li>
              <Link
                to="/#"
                //   className={
                //     childItem.children && childItem.children.length > 0
                //       ? "has-arrow"
                //       : ""
                //   }
              >
                {/* <i className={returnImgByMenuCode(childItem.menuCode)}></i> */}
                <i className={returnIconByMenuCode(childItem.menuCode)}></i>
                <span className="badge rounded-pill bg-info float-end"></span>
                <span>{childItem.menuName}</span>
              </Link>
              <ul className="sub-menu">
                {childItem.children.map((child, index1) => {
                  let dataHref = "";
                  if (
                    child.moreAccessLink &&
                    child.moreAccessLink !== undefined
                  ) {
                    dataHref = child.moreAccessLink.join("___");
                  }
                  return (
                    <li key={child.id}>
                      <Link
                        className={
                          child.children && child.children.length > 0
                            ? "has-arrow"
                            : ""
                        }
                        to={child.accessLink.toLowerCase().split("_").join("-")}
                        datahref={dataHref}
                      >
                        {/* <i
                      className={returnImg(
                        child.accessLink.toLowerCase().split("_").join("-")
                      )}
                    ></i> */}
                        <span>{child.menuName}</span>
                      </Link>
                      {/* {child.children &&
                child.children.map((sub, keyIndex) => (
                  <ul key={keyIndex} className="sub-menu" aria-expanded="false">
                    <li>
                      <Link to="/ecommerce-products">{sub.menuName}</Link>
                    </li>
                  </ul>
                ))} */}
                    </li>
                  );
                })}
              </ul>
            </li>
            {/* <li key={index} className="menu-title">
            {childItem.menuName}
          </li> */}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

ConfigMenu.propTypes = {
  menuApi: PropTypes.array,
};

export default ConfigMenu;
